(function () {
  function initSalePromoCountdown(container) {
    if (!container) return;

    var countdownEl = container.querySelector(".sale-countdown");
    if (!countdownEl || countdownEl.dataset.countdownInit === "true") return;

    var endTimeString = countdownEl.getAttribute("data-endtime");
    var countDownDate = Date.parse(endTimeString);

    if (!countDownDate || isNaN(countDownDate)) {
      console.error("Invalid countdown date:", endTimeString);
      return;
    }

    var daysEl = countdownEl.querySelector('[id^="days_id-"]');
    var hoursEl = countdownEl.querySelector('[id^="hours_id-"]');
    var minutesEl = countdownEl.querySelector('[id^="minutes_id-"]');
    var secondsEl = countdownEl.querySelector('[id^="seconds_id-"]');
    var saleEndsText = container.querySelector(".sale-ends-text");
    var expireText = countdownEl.getAttribute("data-expire-text") || "Sale ended";

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    countdownEl.dataset.countdownInit = "true";
    var timer;

    function updateCountdown() {
      var distance = countDownDate - Date.now();

      if (distance <= 0) {
        clearInterval(timer);
        daysEl.textContent = "00";
        hoursEl.textContent = "00";
        minutesEl.textContent = "00";
        secondsEl.textContent = "00";
        if (saleEndsText) saleEndsText.textContent = expireText;
        return;
      }

      daysEl.textContent = String(Math.floor(distance / (1000 * 60 * 60 * 24))).padStart(2, "0");
      hoursEl.textContent = String(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))).padStart(2, "0");
      minutesEl.textContent = String(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
      secondsEl.textContent = String(Math.floor((distance % (1000 * 60)) / 1000)).padStart(2, "0");
    }

    updateCountdown();
    timer = setInterval(updateCountdown, 1000);
  }

  function boot(root) {
    if (root) {
      initSalePromoCountdown(root);
      return;
    }

    document.querySelectorAll(".sale-page-banner-container").forEach(initSalePromoCountdown);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector(".sale-page-banner-container")
      : null;
    if (root) {
      boot(root);
    } else {
      boot();
    }
  });
})();
